export enum NotesTypeText {
  CCIM_NOTE = 'CCIM',
  CHASE_NOTE = 'Chase',
  CONTRACTOR_NOTE = 'Contractor',
  OTHER_NOTE = 'Other',
}
